import { Brand } from "../brand/brands";
import { Resource } from "../resource";


export class ProductLine extends Resource {
    brand: Brand
    image: string
    text: string
    title: string
}